<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="warehouseOrder">
      <el-form ref="orderForm" :model="orderForm">
        <div class="wrap">
          <div class="main">
            <main class="main__content">
              <div class="step__sections" v-if="!submmited">
                <div class="section section--shipping-address">
                  <!-- customer information start-->
                  <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                    <div class="title">
                      <span>卡车派送使用说明</span>
                    </div>
                    <div class="ltl-list">
                      <p>卡车派送分FTL（Full Truck Load）和LTL（less than truck load</p>
                    </div>
                    <div class="ltl-list">
                      <p v-html="$t('ltl1')"></p>
                    </div>
                    <div class="ltl-list">
                      <p v-html="$t('ltl2')"></p>
                    </div>
                    <div class="ltl-list">
                      <p v-html="$t('ltl3')"></p>
                    </div>
                    <div class="ltl-list">
                      <p v-html="$t('ltl4')"></p>
                    </div>
                    <div class="ltl-list">
                      <p v-html="$t('ltl5')"></p>
                    </div>
                    <div class="ltl-list">
                      <p v-html="$t('ltl6')"></p>
                    </div>
                    <div class="ltl-list">
                      <p v-html="$t('ltl7')"></p>
                    </div>
                    <div class="fieldset">
                      <el-row :gutter="20">
                        <el-col :span="8">
                          <button class="btn" @click="goToXPO">
                            <span>{{ $t("ltl") }}</span>
                          </button>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
              
              </div>
            </main>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {Alert} from "element-ui";
  import axios from "axios";
  import breadcrumb from "../../components/breadcrumb";

  export default {
    name: "outboundNoInv",
    components: {
      breadcrumb,
    },
    data() {
      return {
        path2: this.$t("header3"),
      };
    },
    methods: {
      goToXPO() {
        this.$router.push({name: 'outboundXPONoInv'});
      },
    },
    mounted() {
      this.$store.dispatch('orders/fetchInboundProducts');
      this.$store.dispatch("addresses/fetchAddresses");
      this.$store.dispatch("addresses/fetchWarehouseAddresses");
    },
  };
</script>

<style lang="less">
  @import "../../assets/css/warehouseOrder.less";
</style>



// WEBPACK FOOTER //
// src/view/Service/outboundNoInv.vue